import { StaticModal, createModal } from '@nexelem/modals';
import { Button } from '@nexelem/components';
import type { SimulationTasksUpdates } from '@nexelem/graphne-api';
import { useCustomTranslation } from '../../../../../hooks/useCustomTranslation';
import { useSaveAndRecalculate } from '../hooks';

type RecalculateModalProps = {
  simulationTasksUpdates: SimulationTasksUpdates;
};

export const RecalculateModal = ({ simulationTasksUpdates }: RecalculateModalProps) => {
  const { tWrapper } = useCustomTranslation('products.simulationPlan');
  const { handleSaveAndRecalculate, isLoading } = useSaveAndRecalculate({ simulationTasksUpdates });

  return (
    <StaticModal component="form" maxWidth="lg" onClose={closeRecalculateModal}>
      <StaticModal.Header withCloseButton>{tWrapper('recalculateModalTitle')}</StaticModal.Header>
      <StaticModal.Content>
        <div className="text-s18">{tWrapper('recalculateModalContent')}</div>
      </StaticModal.Content>
      <StaticModal.Footer>
        <Button variant="outlined" onClick={closeRecalculateModal}>
          {tWrapper('simulationCancel')}
        </Button>
        <Button isLoading={isLoading} variant="contained" onClick={handleSaveAndRecalculate}>
          {tWrapper('recalculateModalConfirm')}
        </Button>
      </StaticModal.Footer>
    </StaticModal>
  );
};

export const { openRecalculateModal, closeRecalculateModal } = createModal(RecalculateModal, {
  name: 'RecalculateModal',
});
